module.exports = __webpack_public_path__ + "img/Brand_Banner1.7c5d837c.png";